import { GraduationCap, HeartHandshake, BookOpen } from "lucide-react";

export default function About() {
  return (
    <section id="about" className="relative py-20 lg:py-28 bg-sunlit-cream" data-testid="about-section">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5">
            <div className="relative">
              <div className="absolute -top-4 -left-4 h-24 w-24 rounded-full bg-sunlit-gold/30 blur-2xl" />
              <div className="relative rounded-3xl overflow-hidden border border-stone-200 shadow-md">
                <img
                  src="https://customer-assets.emergentagent.com/job_joy-clarity-sessions/artifacts/d7zlm77t_image.png"
                  alt="A grand bouquet of yellow roses gift-wrapped in yellow paper"
                  className="w-full h-[460px] object-cover"
                />
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <p className="text-xs uppercase tracking-[0.2em] text-sunlit-mute mb-4">
              About your coach
            </p>
            <h2 className="font-serif-display text-4xl sm:text-5xl text-sunlit-ink leading-tight">
              A physiologist by training. <br />
              A <span className="italic text-sunlit-gold">happiness practitioner</span> by calling.
            </h2>
            <div className="mt-7 space-y-4 text-base sm:text-lg text-sunlit-mute leading-relaxed">
              <p>
                I teach the inner functions of the human body in a medical school — and somewhere along the way I realised something deeper: a healthy body is only half the story — A peaceful inner self is the other half.
              </p>
              <p>
                That curiosity led me to become a Certified Happiness Coach. Now, alongside academia, I dedicate time to people who are quietly ready to change — to soften, to listen, to choose Happiness on purpose.
              </p>
              <p className="font-serif-display text-2xl italic text-sunlit-ink">
                "I do this as a hobby, but I hold my time sacred."
              </p>
            </div>

            <div className="mt-10 grid sm:grid-cols-3 gap-4">
              <Credential icon={GraduationCap} title="MD Physiology" sub="Assistant Professor" />
              <Credential icon={HeartHandshake} title="Certified Coach" sub="Happiness practices" />
              <Credential icon={BookOpen} title="Lifelong learner" sub="Books, reflection, finding yourself" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Credential({ icon: Icon, title, sub }) {
  return (
    <div className="rounded-2xl bg-sunlit-ivory border border-stone-200/70 p-5 hover:-translate-y-0.5 hover:shadow-md transition-all" data-testid={`credential-${title.toLowerCase().replace(/\s+/g, "-")}`}>
      <div className="h-9 w-9 rounded-full bg-sunlit-gold/20 flex items-center justify-center mb-3">
        <Icon className="h-4 w-4 text-sunlit-gold" />
      </div>
      <p className="font-serif-display text-lg text-sunlit-ink leading-tight">{title}</p>
      <p className="text-xs text-sunlit-mute mt-1">{sub}</p>
    </div>
  );
}
